// extracted by mini-css-extract-plugin
export var labelWrapper = "_ho-0";